import { IBookInfo } from "@/domain/entities/book";
import { useBookStore } from "@/stores/bookStore";
import {
  BookStatus,
  BookStatusName,
  BookStatusType,
  PROVIDE_KEY_SHOW_ERROR_MODAL,
  ShowErrorModal,
} from "@/types";
import { BookInfoRequest } from "./useGetBookInfoRequest";
import { inject } from "vue";

const bookStore = useBookStore();

const getBookInfos = async (request: BookInfoRequest) => {
  const bookInfosResult = await bookStore.getBookInfos(
    request.bookStatusCode,
    request.sort,
    request.dateCriteria,
    request.fromDate,
    request.dateCriteria,
    request.toDate
  );
  return bookInfosResult;
};

export function useGetFilteredBookInfos() {
  const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;

  const getFilteredBookInfos = async (
    request: BookInfoRequest,
    bookStatus: BookStatusType,
    filterBookStatus = "전체"
  ): Promise<IBookInfo[]> => {
    const bookInfosResult = await getBookInfos(request);

    if (!bookInfosResult.isSuccess) {
      showErrorModal(
        "예약목록 오류",
        bookInfosResult.errorMessage,
        bookInfosResult.resultCode,
        bookInfosResult.errorTime
      );
    }

    const bookInfos = bookInfosResult.data ?? [];

    switch (bookStatus) {
      case BookStatus.Book:
        return bookInfos.filter(
          (bookInfo) => bookInfo.bookStatus === BookStatusName.BOOK
        );
      case BookStatus.PastBook:
        return bookInfos.filter(
          (bookInfo) =>
            bookInfo.bookStatus !== BookStatusName.BOOK &&
            (filterBookStatus === "전체" ||
              bookInfo.bookStatus === filterBookStatus)
        );
      case BookStatus.All:
        return bookInfos.filter(
          (bookInfo) =>
            filterBookStatus === "전체" ||
            bookInfo.bookStatus === filterBookStatus
        );
      default:
        return [];
    }
  };

  return { getFilteredBookInfos };
}
